import React, { Component, Fragment } from "react";
import "./newSampleRequest.css";

//services
import { NewSampleRequestServices } from "../../services";

//components
import PageHeader from "../../components/Page/PageHeader/PageHeader";
import Loading from '../../components/Common/Loading'

class NewSampleRequest extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    active: false,
    isLoading: false,
    newsampleObj: {},
    toggle: true
  };

  componentDidMount() {
    const { action, _id } = this.props.location.state;
    this.setState({
      isLoading: true
    })

    if (action == "view") {
      this.setState({
        isLoading: true
      })
      NewSampleRequestServices.newsamplerequestUser(_id)
        .then(async response => {
          if (response.status === 200) {
            this.setState({
              newsampleObj: response.text,
              isLoading: false
            });
            
          }
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage('error', error.toString()));
    }

    this.setState({ action, _id });
  }




  render() {
    const { newsampleObj } = this.state;
    const { requestNumber, currentDepartment, percentageCompleted, style, stages, originationOfRequest, sampleType, typeOfRequest, orderDate } = newsampleObj || {};
    const { name, assignedTo, ETA, processDate, status } = currentDepartment || {};
    const { style_no, style_name, garment_type, fabric_type } = style || {};
    console.log(originationOfRequest, "564545121");

    return (
      <Fragment>
        {this.state.isLoading && <Loading />}
        <div className="right-section bg-white">
          <div className="row nopadding">
            <div className="col-md-12 nopadding">
              <PageHeader
                history={this.props.history}
                header={"NEW SAMPLE REQUEST DETAILS"}
              />
            </div>
          </div>
          <div className="newsampletop">
            <div className="newsampletopcontent">
              <p className="newsamplehead">
                {requestNumber && requestNumber !== null ? requestNumber : "-"}
              </p>
              <span>{status && status !== null ? status : "-"}</span>
            </div>
            <ul className="newsampletabs">
              <li>
                <button type="button" className={`btn ${this.state.toggle === true ? "active primary" : ""}`} onClick={() => this.setState({ toggle: true })}>Overview</button>
              </li>
              <li>
                <button type="button" className={`btn ${this.state.toggle === false ? "active primary" : ""}`} onClick={() => this.setState({ toggle: false })}>Process Flow</button>
              </li>
            </ul>
            {
              this.state.toggle ?
                <Fragment>
                  <div className="newsampledetailbox">
                    <div>
                      <div className="newsampletabbox">
                        <p className="newsampletaboxhead">Request Details</p>
                        <div className="newsampletabox">
                          <ul>
                            <li>
                              <span>Style No:</span>
                              {style_no && style_no !== null ? style_no : "-"}
                            </li>
                            <li>
                              <span>Style Name:</span>
                              {style_name && style_name !== null ? style_name : "-"}
                            </li>
                            <li>
                              <span>Garment Type:</span>
                              {garment_type && garment_type !== null ? garment_type : "-"}
                            </li>
                            <li>
                              <span>Fabric Type:</span>
                              {fabric_type && fabric_type !== null ? fabric_type : "-"}
                            </li>
                            <li>
                              <span>Origination of Request:</span>
                              {originationOfRequest && originationOfRequest !== null ? originationOfRequest : "-"}
                            </li>
                            <li>
                              <span>Sample Type:</span>
                              {sampleType && sampleType !== null ? sampleType : "-"}
                            </li>
                            <li>
                              <span>Type of Request:</span>
                              {typeOfRequest && typeOfRequest !== null ? typeOfRequest : "-"}
                            </li>
                            <li>
                              <span>Order Date:</span>
                              {orderDate && orderDate !== null ? orderDate : "-"}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div className="newsampletabbox">
                        <p className="newsampletaboxhead">Assignment & Status</p>
                        <div className="newsampletabox">
                          <ul>
                            <li>
                              <span>Name:</span>
                              {name && name !== null ? name : "-"}
                            </li>
                            <li>
                              <span>Assigned To:</span>
                              {assignedTo && assignedTo !== null ? assignedTo : "-"}
                            </li>
                            <li>
                              <span>ETA:</span>
                              {ETA && ETA !== null ? ETA : "-"}
                            </li>
                            <li>
                              <span>Process Date:</span>
                              {processDate && processDate !== null ? processDate : "-"}
                            </li>
                            <li>
                              <span>Status:</span>
                              {status && status !== null ? status : "-"}
                            </li>
                            <li>
                              <span>Percentage:</span>
                              {percentageCompleted && percentageCompleted !== null ? percentageCompleted : "-"}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="progressbox">
                    <div className="progressboxhead">
                      <p>Overall Progress</p>
                      <span>{percentageCompleted && percentageCompleted !== null ? percentageCompleted : 0}</span>
                    </div>
                    <div className="progress">
                      <div className="progress-bar" role="progressbar" style={{ width: `${percentageCompleted && percentageCompleted !== null ? percentageCompleted : 0}` }}>
                        <span className="sr-only">60% Complete</span>
                      </div>
                    </div>
                  </div>
                </Fragment> : <Fragment>
                  <div className="processtimeline">
                    <p className="processtimelinehead">Process Timeline</p>
                    <div className="processtimelinetop">
                      {
                        (stages || []).map((stage, index) => {
                          const { name, assignedTo, status, processDate, ETA } = stage || {};
                          return (
                            <div className="processtimelinebox">
                              <div>
                                <span className={`processtimelinebadge ${status.toLowerCase() === "completed" ? "completed" : status.toLowerCase() === "pending" ? "pending" : status.toLowerCase() === "in process" ? "inprocess" : status.toLowerCase() === "cancel" ? "cancel" : ""}`}></span>
                              </div>
                              <div>
                                <p>{name && name !== null ? name : "-"}</p>
                                <span>Assigned to: {assignedTo && assignedTo !== null ? assignedTo : "-"}</span>
                                <div className="processtimelineboxflex">
                                  <span>status: {status && status !== null ? status : "-"}</span>
                                  <span>process date: {processDate && processDate !== null ? processDate : "-"}</span>
                                  <span>ETA {ETA && ETA !== null ? ETA : "-"}</span>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                </Fragment>
            }
          </div>
        </div>
      </Fragment>
    );
  }
}
export default NewSampleRequest;



// WEBPACK FOOTER //
// ./src/pages/newSampleRequest/page.js